import BarGraph from "./BarGraph";

export default BarGraph;
